


















/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
     Sections
 ---------------------------------------- */

import Contact from '@part/cases/Contact.vue';
import PageHeader from '@layout/header/PageHeader.vue';

/* ----------------------------------------
    Module Helper
---------------------------------------- */

import { StoreModule } from "@store/service/Modules";
const module = new StoreModule('news');

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    components: {
        Contact,
        PageHeader
    },

    computed: {
        header() {
            const content = this.news;
            const date = this.date(content.created);
            const format = `Update | ${ date.dayName } ${ date.day } of ${ date.monthName } ${ date.year }`;

            return {
                size: 'medium',
                title: content.title,
                subtitle: {
                    eng: format,
                    nl: format
                },
                text: content.intro,
                image: {
                    src: content.images.header
                }
            }
        },

        news() {
            const id = this.$route.params.id;
            return module.getters('getNewsById', id);
        },
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class News extends Vue {}

